import PropTypes from "prop-types";
import React, { Component } from "react";
import StepContent from "./wizard/StepContent";
import { connect } from "react-redux";

class SubWizard extends Component {
  prepareSteps = (steps, activeStep) => {
    const _stepsContent = [];
    for (const stepKey in steps) {
      if (Object.prototype.hasOwnProperty.call(steps, stepKey)) {
        const step = steps[stepKey];

        _stepsContent.push(
          <StepContent
            key={`${stepKey}-sub-content`}
            isValid={this.props.isValid}
            step={step}
            active={activeStep.subStep === +stepKey}
          />
        );
      }
    }
    return { stepsContent: _stepsContent };
  };

  render() {
    const { steps, activeStep } = this.props;
    const { stepsContent } = this.prepareSteps(steps, activeStep);
    return <React.Fragment>{stepsContent}</React.Fragment>;
  }
}

SubWizard.propTypes = {
  activeStep: PropTypes.any,
  isValid: PropTypes.any,
  steps: PropTypes.any
};

const mapStateToProps = state => {
  return {
    activeStep: state.activeStep
  };
};

export default connect(
  mapStateToProps,
  null
)(SubWizard);
